"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var StyledI = styled_components_1.default.i(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tborder: solid #333;\n\tborder-width: 0 5px 5px 0;\n\tdisplay: inline-block;\n\tpadding: 3px;\n\theight: 20px;\n\twidth: 20px;\n\tcursor: pointer;\n\n\t&:hover {\n\t\topacity: 0.4;\n\t}\n\n\ttransform: ", ";\n\n\t", "\n"], ["\n\tborder: solid #333;\n\tborder-width: 0 5px 5px 0;\n\tdisplay: inline-block;\n\tpadding: 3px;\n\theight: 20px;\n\twidth: 20px;\n\tcursor: pointer;\n\n\t&:hover {\n\t\topacity: 0.4;\n\t}\n\n\ttransform: ", ";\n\n\t", "\n"])), function (_a) {
  var direction = _a.direction;
  return direction === 'left' ? 'rotate(135deg)' : 'rotate(-45deg)';
}, function (_a) {
  var direction = _a.direction;
  return direction === 'left' ? 'margin-left: 1em;' : 'margin-right: 1em;';
});

var Arrow = function Arrow(_a) {
  var
  /* eslint-disable react/prop-types */
  ArrowComponent = _a.ArrowComponent,
      arrowStyle = _a.arrowStyle,
      onClick = _a.onClick,
      direction = _a.direction
  /* eslint-enable react/prop-types */
  ;

  if (ArrowComponent) {
    return react_1.default.createElement(ArrowComponent, {
      direction: direction,
      onClick: onClick
    });
  }

  return react_1.default.createElement("a", {
    onClick: onClick
  }, react_1.default.createElement(StyledI, {
    style: arrowStyle,
    direction: direction
  }));
};

Arrow.defaultProps = {
  ArrowComponent: undefined,
  arrowStyle: {}
};
exports.default = Arrow;
var templateObject_1;